import React from "react";
import {
  Container,
  SpaceBetween,
  Box,
  Button,
  ColumnLayout,
} from "@amzn/awsui-components-react";

export const Migration = () => {
  const handleContinue = () => {
    window.location.href = "https://partnercentral.awspartner.com";
  };

  return (
    <div className="migration-page" style={{ padding: "40px 20px" }}>
      <div style={{ maxWidth: "800px", margin: "0 auto" }}>
        <Container>
          <SpaceBetween size="l">
            <Box variant="h1" fontWeight="heavy">
              Partner Central 3.0 Migration
            </Box>

            <ColumnLayout columns={1} variant="text-grid">
              <div>
                <Box variant="awsui-key-label">Description</Box>
                <div>
                  If you have migrated to <strong>Partner Central 3.0</strong>, please access your funding portal through{" "}
                  <a href="https://partnercentral.awspartner.com" target="_blank" rel="noopener noreferrer">
                    Partner Central 3.0
                  </a>.
                  <br /><br />
                  If you haven&apos;t migrated yet, we encourage you to complete your migration 
                  to Partner Central 3.0 to continue accessing funding opportunities 
                  and the latest partner resources.
                </div>
              </div>
            </ColumnLayout>

            <Box textAlign="right">
              <Button variant="primary" onClick={handleContinue}>
                Continue
              </Button>
            </Box>
          </SpaceBetween>
        </Container>
      </div>
    </div>
  );
};

export default Migration;
